import { RouteConfig } from 'vue-router';

const Doctor = () => import('../doctor/doctor.vue');
const Patient = () => import('../patient/patient.vue');
const Content = () => import('../content/content.vue');
const Shaicha = () => import('../shaicha/shaicha.vue');
const Statistics = () => import('../statistics/statistics.vue');
const Setting = () => import('../setting/setting.vue');
const Ceping = () => import('../ceping/ceping.vue');

import DoctorRouters from "../doctor/doctor.router";
import PatientRouters from "../patient/patient.router";
import ContentRouters from "../content/content.router";
import ShaichaRouters from "../shaicha/shaicha.router";
import StatisticsRouters from "../statistics/statistics.router";
import SettingRouters from "../setting/setting.router";
import CepingRouters from "../ceping/ceping.router";


const routers: RouteConfig[] = [
    {
        path: 'doctor',
        component: Doctor,
        children: DoctorRouters
    },
    {
        path: 'patient',
        component: Patient,
        children: PatientRouters
    },
    {
        path: 'content',
        component: Content,
        children: ContentRouters
    },
    {
        path: 'shaicha',
        component: Shaicha,
        children: ShaichaRouters
    },
    {
        path: 'statistics',
        component: Statistics,
        children: StatisticsRouters
    },
    {
        path: 'setting',
        component: Setting,
        children: SettingRouters
    },
    {
        path: 'ceping',
        component: Ceping,
        children: CepingRouters
    },
    {
        path: '',
        redirect: 'doctor'
    },
]
export default routers;
